import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import DatePicker from "material-ui/DatePicker";
import areIntlLocalesSupported from "intl-locales-supported";
import {
  changeDate,
  fetchDispatch,
  copyAllTeams,
  pasteTeams,
  copyItem,
  updateVisibility,
} from "../Dispatch/actions";
import TestDatePicker from "../../Components/Select/TestDatePicker";
import PrintIcon from "../../Components/Buttons/PrintIcon";
import moment from "moment";
import "moment/locale/fr-ca";
let DateTimeFormat;

/**
 * Use the native Intl.DateTimeFormat if available, or a polyfill if not.
 */
if (areIntlLocalesSupported(["fr", "fa-IR"])) {
  DateTimeFormat = global.Intl.DateTimeFormat;
} else {
  const IntlPolyfill = require("intl");
  DateTimeFormat = IntlPolyfill.DateTimeFormat;
  require("intl/locale-data/jsonp/fr");
  require("intl/locale-data/jsonp/fa-IR");
}

export class SnackBar extends Component {
  datePicker = () => {
    const { date } = this.props;
    return (
      <div className="datepicker-container">
        <DatePicker
          hintText="Landscape Inline Dialog"
          container="inline"
          autoOk
          formatDate={formatDate}
          locale="fr"
          DateTimeFormat={DateTimeFormat}
          okLabel="OK"
          cancelLabel="Annuler"
          onChange={this.handleDateChange}
          value={this.unformatDate(date)}
          firstDayOfWeek={0}
        />
        <span
          className="btn btn-default blue-button"
          onClick={this.handleTodayClick}
        >
          Aujourd'hui
        </span>
        <TestDatePicker handleVisibility={this.handleVisibility} />
        <span className="weekday">({moment(date).format("dddd")})</span>
      </div>
    );
  };

  handleDateChange = (e, date) => {
    const { onFetchDispatch } = this.props;
    const formatedDate = formatDate(date);
    onFetchDispatch(formatedDate);
  };

  handleTodayClick = () => {
    const { onFetchDispatch } = this.props;
    onFetchDispatch();
  };

  handleVisibility = (visible) => {
    const { date, onUpdateVisibility } = this.props;
    onUpdateVisibility(date, visible);
  };

  unformatDate = (formattedDate) => {
    if (formattedDate) {
      const dateParts = formattedDate.split("-");
      return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    }
  };

  clearPaste = () => {
    const { onCopyItem } = this.props;
    onCopyItem("", null, null);
  };

  render() {
    const {
      onCopyAllTeams,
      onPasteTeams,
      copyType,
      teams,
      copyPayload,
    } = this.props;

    return (
      <div className="dispatch-container dispatch-snackbar">
        {this.datePicker()}
        <div className="row fixed-bar">
          <div className="utils-btn-container">
            <button
              disabled={Object.keys(teams).length < 1}
              onClick={onCopyAllTeams}
              className="snackbar-button"
              title="Copier tout"
            >
              <i className="fa copy-icon fa-files-o" aria-hidden="true" />
            </button>

            <button
              onClick={onPasteTeams}
              className="snackbar-button"
              disabled={copyType !== "teams"}
              title="Coller"
            >
              <i className="fa fa-paste" aria-hidden="true" />
            </button>

            <button
              disabled={Object.keys(teams).length < 1}
              onClick={window.print}
              className="snackbar-button"
              title="Imprimer"
            >
              <PrintIcon />
            </button>
            <button
              disabled={copyPayload === null}
              onClick={this.clearPaste}
              className="snackbar-button"
              title="Vider le presse-papier"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  date: state.dispatch.date,
  copyType: state.dispatch.copyType,
  teams: state.dispatch.teams,
  copyPayload: state.dispatch.copyPayload,
});

const mapDispatchToProps = (dispatch) => ({
  onChangeDate: (date) => dispatch(changeDate(date)),
  onFetchDispatch: (date) => dispatch(fetchDispatch(date)),
  onCopyAllTeams: () => dispatch(copyAllTeams()),
  onPasteTeams: () => dispatch(pasteTeams()),
  onCopyItem: (a, b, c) => dispatch(copyItem(a, b, c)),
  onUpdateVisibility: (date, visible) =>
    dispatch(updateVisibility(date, visible, true)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(SnackBar);

export const isSmallerThanTen = (number) => {
  if (number < 10) {
    return `0${number}`;
  } else {
    return number;
  }
};
export const formatDate = (date) => {
  return `${date.getFullYear()}-${isSmallerThanTen(
    date.getMonth() + 1
  )}-${isSmallerThanTen(date.getDate())}`;
};
